import {Component, Input, Output, EventEmitter, AfterViewInit} from '@angular/core';
import {Influencer} from '../../../../models/influencer';
import {Platform} from '../../../../models/platform';
import {UserService} from '../../../services/user.service';
import {PlatformSettings} from '../../../../models/platform-settings/platform-settings';
import {ColorPickerService, Rgba} from 'ngx-color-picker';

@Component({
  selector: 'preview-selected-influencers',
  templateUrl: './preview-selected-influencers.component.html',
  styleUrls: ['./preview-selected-influencers.component.scss']
})
export class PreviewSelectedInfluencersComponent implements AfterViewInit {

  @Input() activateBottomBar = false;
  @Input() listInfluencers: Influencer[] = [];
  @Input() platformList: Platform[] = [];
  @Input() displayInfo: string;

  private platformSetting: PlatformSettings;

  constructor(private userService: UserService,
              private cpService: ColorPickerService) {
    this.userService.platformSettings.subscribe(setting => {
      this.platformSetting = setting;
    });
  }

  ngAfterViewInit() {
    // update the bg color for each line of preview bottom bar
    if (this.activateBottomBar) {
      const bottombarColor = this.cpService.stringToHsva(this.platformSetting.bottombarBgColor, true);
      const bottombarColorRgba = this.cpService.denormalizeRGBA(this.cpService.hsvaToRgba(bottombarColor));

      // build the darker color base on the background color of bottombar
      const darkColorR = bottombarColorRgba.r > 21 ? bottombarColorRgba.r - 21 : bottombarColorRgba.r;
      const darkColorG = bottombarColorRgba.g > 22 ? bottombarColorRgba.g - 22 : bottombarColorRgba.g;
      const darkColorB = bottombarColorRgba.b > 23 ? bottombarColorRgba.b - 23 : bottombarColorRgba.b;
      const darkColorA = bottombarColorRgba.r > 21 || bottombarColorRgba.g > 22 || bottombarColorRgba.b > 23 ? 0.2 : 1;

      const reviewInfluencerEvenLines = document.querySelectorAll('.bottombar .influencer-preview-container.even');
      const reviewInfluencerOddLines = document.querySelectorAll('.bottombar .influencer-preview-container.odd');

      // using the darker color for even line
      [].forEach.call(reviewInfluencerEvenLines, (line) => {
        line.style.backgroundColor = 'rgba(' + darkColorR + ',' + darkColorG + ',' + darkColorB + ',' + darkColorA + ')';
      });

      // using the background color of bottombar for odd line
      [].forEach.call(reviewInfluencerOddLines, (line) => {
        line.style.backgroundColor = this.platformSetting.bottombarBgColor;
      });
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/main/group-details/preview-selected-influencers/preview-selected-influencers.component.ts